import { ReactNode } from 'react';
import { usePlanSidebar } from '@/contexts/plan-sidebar-context';
import PlanSidebar from '@/components/plan-sidebar';
import PlanToggleButton from '@/components/plan-toggle-button';
import { useAuth } from '@/lib/auth';

interface BrowseLayoutProps {
  children: ReactNode;
}

export function BrowseLayout({ children }: BrowseLayoutProps) {
  const { user } = useAuth();
  const { isOpen, toggle, open } = usePlanSidebar();

  return (
    <>
      {/* Main content - adjusts margin when sidebar is open */}
      <div className={`transition-[margin] duration-300 ease-in-out ${isOpen ? 'lg:mr-96' : 'lg:mr-0'}`}>
        {children}
      </div>

      {/* Plan Sidebar */}
      {user && <PlanSidebar isOpen={isOpen} onToggle={toggle} />}

      {/* Plan Toggle Button - hidden when sidebar open */}
      {user && !isOpen && <PlanToggleButton onClick={open} />}
    </>
  );
}
